module.exports = __webpack_public_path__ + "img/c2.a9333037.png";